import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { Container } from 'react-modal-promise';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { CacheProvider, Global } from '@emotion/react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';

import store from 'store';
import AwsAuthenticator from 'auth/components/Auth/AwsAuthenticator';
import { LogoutProvider } from 'shared/context/LogoutContext';
import Snackbar from 'shared/components/feedback/Snackbar/Snackbar';
import VersionChecker from 'shared/components/version/VersionChecker';
import AppRoutes from 'navigation/AppRoutes';
import globalStyles from 'styles/global';
import theme from 'styles/theme';
import { createEmotionCache } from './emotionCache';

import * as serviceWorker from './serviceWorker';

const emotionCache = createEmotionCache();
const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <CacheProvider value={emotionCache}>
      <StyledEngineProvider>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <VersionChecker />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Global styles={globalStyles} />
              <AwsAuthenticator>
                <LogoutProvider>
                  <AppRoutes />
                </LogoutProvider>
              </AwsAuthenticator>
              <Snackbar />
              <Container />
            </LocalizationProvider>
          </BrowserRouter>
        </ThemeProvider>
      </StyledEngineProvider>
    </CacheProvider>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
